<template>
  <div class="content-box">
    <fieldset>
      <v-card-title>Extended Passport</v-card-title>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.ini.sstm.id') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="client.sysid" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.ini.svc.type') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="client.service | comma" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.user.id') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="client.userid" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.ini.act') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="client.action" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.ini.act.type') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="client.acttype | comma" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row><v-col cols="12" style="height:29px"></v-col></v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.prev.cmpnt.nm') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="passport.precomponentname" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.root.ctxt.id') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="passport.rootContextId" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.clnt') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="passport.client" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.conn.id') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="passport.connectionId" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.conn.counter') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="passport.connectionCounter | comma" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
    </fieldset>
  </div>
</template>

<script>
import { api } from '../../../api/common/instances';
import tabable from './tabable';

export default {
  mixins: [tabable],
  data() {
    return {
      client: {},
      passport: [],
    };
  },
  methods: {
    async fetch(params) {
      ({ data: this.client } = await api.get('/analysis/ssrviewer/detail/clientinfo', { params }));
      ({ data: this.passport } = await api.get('/analysis/ssrviewer/detail/passportrecs', { params }));
      this.increaseLoadingCount();
    },
  },
};
</script>

<style lang="scss" scoped>
@import './tab';
</style>
